import { makeAutoObservable } from "mobx";
import { User } from "../Model/user";
import {
  signInWithEmailAndPassword,
  getAuth,
  signOut,
  Persistence,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase";
import axios from "axios";

export interface Store {
  id: string;
  companyId: string;
  storeName: string;
  storeId: string;
}

export class Authenticator {
  signedInUser: User | null = null;
  loaded: boolean = false;
  stores: Store[] = [];
  focusedStore: Store | undefined = undefined;
  constructor() {
    makeAutoObservable(this);
    auth.onAuthStateChanged((u) => {
      if (u !== null) {
        if (auth.currentUser) {
          console.log(auth.currentUser);
          this.signedInUser = {
            UID: auth.currentUser.uid,
            email: auth.currentUser.email,
          } as User;

          this.loaded = false;
          axios
            .get(`https://wallof-backend.uc.r.appspot.com/employee/authorize`, {
              headers: {
                Authorization: `Bearer ${auth.currentUser.uid}`,
              },
            })
            .then((d) => {
              console.log(d);
              if (d.data) {
                this.stores = d.data as Store[];
                if (this.stores.length > 0) {
                  this.focusedStore = this.stores[0];
                }
                this.stores.push({
                  companyId: "",
                  id: "new-company",
                  storeId: "new-store",
                  storeName: "Add New Store",
                });
              }
              this.loaded = true;
            })
            .catch((e) => {
              console.error(e);
              this.loaded = true;
            });
        }
      }
      this.loaded = true;
    });
  }

  public isSignedIn(): Boolean {
    return this.signedInUser !== null;
  }

  public async signIn(email: string, password: string) {
    this.loaded = false;
    signInWithEmailAndPassword(auth, email, password)
      .then((user) => {
        this.loaded = true;
        this.signedInUser = {
          UID: user.user.uid,
          email: user.user.email,
        } as User;
        console.log("Successfully Signed In");
      })
      .catch((e) => {
        this.signedInUser = null;
        console.error(e);
      });
  }

  public async signUp(email: string, password: string) {
    createUserWithEmailAndPassword(auth, email, password)
      .then((newUser) => {})
      .catch((e) => {});
  }

  public signOut() {
    signOut(auth)
      .then((e) => {
        this.signedInUser = null;
      })
      .catch((e) => {});
  }

  public async addStore(store: Store) {
    this.loaded = false;
    if (auth.currentUser) {
      axios
        .post(`https://wallof-backend.uc.r.appspot.com/stores`, store, {
          headers: {
            Authorization: `Bearer ${auth.currentUser.uid}`,
          },
        })
        .then((r) => {
          this.loaded = true;
          console.log(r.data);
        })
        .catch((e) => {
          this.loaded = true;
          console.error(e);
        });
    }
  }
}
